import { ContactAttributesDto } from "../../../contact/models"
import { SearchPayload } from "../../../search/SearchPayload"

// Action types
export const types = {
    FETCH_CONTACTS: "FETCH_CONTACTS" as const,
    FETCH_CONTACTS_SUCCESS: "FETCH_CONTACTS_SUCCESS" as const,
    FETCH_CONTACTS_ERROR: "FETCH_CONTACTS_ERROR" as const
}

// Actions type
export type Actions =
    | { type: typeof types.FETCH_CONTACTS; payload: SearchPayload }
    | { type: typeof types.FETCH_CONTACTS_SUCCESS; payload: Array<ContactAttributesDto> }
    | { type: typeof types.FETCH_CONTACTS_ERROR; payload: { errorMessage: string } }

// Actions
export const fetchContacts = (searchParams: SearchPayload) => {
    return { type: types.FETCH_CONTACTS, payload: searchParams }
}
export const fetchContactsSuccess = (data: Array<Partial<ContactAttributesDto>>) => ({
    type: types.FETCH_CONTACTS_SUCCESS,
    payload: data
})
export const fetchContactsError = (data: { errorMessage: string }) => ({
    type: types.FETCH_CONTACTS_ERROR,
    payload: data.errorMessage
})



// WEBPACK FOOTER //
// ./src/state/listing/contact/actions/actions.ts